import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import FixedBoomExcavator from './FixedBoomExcavator';


// Breadcrumbs Background Image

const FixedBoomExCavatorMachine = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <Header
                navImg={navImg1}
                parentMenu='peak-performance-roofing'
                activeMenu="/peak-performance-roofing"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="Fixed Boom Excavator"
                pageName="Fixed Boom Excavator"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <FixedBoomExcavator />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default FixedBoomExCavatorMachine;